module.exports = __webpack_public_path__ + "media/images/room_menu_icon/machine_prices-147cb64cf063940cd16e24c7435e47a9.png";